import { useAtomValue } from 'jotai';
import { metricKeyIs360MapAtom } from '@/atoms/queries/metric';
import { renderedRadarDataAtom } from '@/atoms/radar';
import { useSelectedCyclesMatching360Check } from './useSelectedCyclesMatching360Check/useSelectedCyclesMatching360Check';

export const useRadar360UnavailableMetricKeys = () => {
  const renderedRadarData = useAtomValue(renderedRadarDataAtom);
  const metricKeyIs360Map = useAtomValue(metricKeyIs360MapAtom);
  const get360Cycles = useSelectedCyclesMatching360Check(true);
  const has360Data = get360Cycles().length > 0;

  if (has360Data) return [];

  return renderedRadarData.filter(({ key }) => metricKeyIs360Map[key]).map(({ key }) => key);
};
